import React, { memo, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { message } from 'antd';
import styles from './UserPortrait.module.less';
import { setWelcomeData } from '../../actions/welcome';
import fail from '../../static/msg-fail.svg';
import select from '../../static/guide_select.png';
import { logging } from '../../actions/log';
import { logNative } from '../../utils/utils';

const selectWelcomeData = createSelector(
  state => state.welcome,
  welcome => welcome.welcomeData,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ handleIsNewUser }) => {
  const [tags, setTags] = useState([]);
  const [checkedUserTypeId, setCheckedUserTypeId] = useState([]);
  const welcomeData = useSelector(selectWelcomeData);
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  // 新用户引导页面展现打桩
  useEffect(() => {
    logNative(
      `userPortrait localStorage： ${new Date()}  ${+new Date() -
        window.PAGE_SESSION_ID} ${JSON.stringify(localStorage)}`,
    );
    dispatch(
      logging({
        category: 'P',
        action: 'Guide',
        label: '',
        param2: {
          source: 'Guide',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime: +new Date() - window.PAGE_SESSION_ID,
          WELCOME_USER: localStorage.getItem('WELCOME_USER'),
          WELCOME_USER_TYPE: localStorage.getItem('WELCOME_USER_TYPE'),
        },
      }),
    );
    localStorage.setItem('WELCOME_USER', 'NO');
  }, []);
  useEffect(() => {
    if (welcomeData) {
      const list = (welcomeData.tags && welcomeData.tags) || [];
      if (!list || list.length < 1) {
        handleIsNewUser(false);
      }
      setTags(list.slice(0, 10));
    }
  }, [welcomeData]);

  const handleCheckedTags = useCallback(
    tag => () => {
      // 标签点击 打桩

      dispatch(
        logging({
          category: 'C',
          action: 'Guide_Tag',
          label: '',
          param2: {
            source: 'Guide',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            tagId: tag.id,
            tagName: tag.tagName,
          },
        }),
      );

      const tagList = welcomeData.tags || [];
      const checked = [...checkedUserTypeId];
      const target = tagList.find(item => item.id === tag.id);
      const findIndex = checked.findIndex(item => item === tag.userTypeId);
      // 点击选中
      if (!target.active) {
        if (findIndex > -1) {
          // 已选择列表有重复的userTypeid
          checked.splice(findIndex, 0, tag.userTypeId);
        } else {
          // 已选择列表没有重复的userTypeid
          checked.push(tag.userTypeId);
        }
      } else {
        // 点击取消
        // eslint-disable-next-line no-lonely-if
        if (findIndex > -1) {
          checked.splice(findIndex, 1);
        }
      }
      if (checked.length > 5) {
        message.destroy();
        message.error({
          content: '您最多可选择5个标签，请取消一个后再选择',
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
        return;
      }
      setCheckedUserTypeId(checked);
      dispatch(
        setWelcomeData({
          tags:
            welcomeData.tags &&
            welcomeData.tags.map(item => {
              return {
                ...item,
                active: tag.id === item.id ? !item.active : item.active,
              };
            }),
        }),
      );
    },
    [checkedUserTypeId, welcomeData],
  );
  const handleSkip = useCallback(
    type => () => {
      if (type === 'default') {
        // 点击跳过打桩
        dispatch(
          logging({
            category: 'C',
            action: 'Guide_Ignore',
            label: '',
            param2: {
              source: 'Guide',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );

        localStorage.setItem('WELCOME_USER_TYPE', JSON.stringify(['1']));
      } else {
        // 点击我选好了打桩
        dispatch(
          logging({
            category: 'C',
            action: 'Guide_Result',
            label: '',
            param2: {
              source: 'Guide',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );

        localStorage.setItem(
          'WELCOME_USER_TYPE',
          JSON.stringify(Array.from(new Set(checkedUserTypeId))),
        );
      }
      localStorage.setItem('WELCOME_USER', 'NO');

      handleIsNewUser(false);
    },
    [checkedUserTypeId],
  );
  return (
    <>
      <div className={styles.popUp_title}>{welcomeData && welcomeData.title}</div>
      <div className={styles.popUp_desc}>{welcomeData && welcomeData.desc}</div>
      <div className={styles.popUp_portrait}>
        {tags &&
          tags.map((tag, index) => (
            <div
              className={classNames(
                styles.popUp_portrait_tag,
                styles[`popUp_portrait_tag${index + 1}`],
                tag.active ? styles.popUp_portrait_active : '',
              )}
              key={index}
              onClick={e => {
                handleCheckedTags(tag, index, e)();
              }}
            >
              {tag.active && (
                <img src={select} alt="" className={styles.popUp_portrait_select}></img>
              )}
              {tag.noSelectIcon && index <= 3 && (
                <img src={tag.noSelectIcon} className={styles.popUp_portrait_img}></img>
              )}
              {tag.selectIcon && index <= 3 && (
                <img
                  src={tag.selectIcon}
                  className={styles.popUp_portrait_img_h}
                  style={{ backgroundImage: `url(${tag.noSelectIcon})` }}
                ></img>
              )}

              {tag.tagName}
            </div>
          ))}
      </div>
      <div className={styles.popUp_portrait_oper}>
        <div
          className={classNames(styles.popUp_portrait_oper_btn, {
            [styles.popUp_portrait_oper_btn_disabled]: checkedUserTypeId.length <= 0,
          })}
          onClick={() => {
            if (checkedUserTypeId && checkedUserTypeId.length > 0) {
              handleSkip()();
            }
          }}
        >
          我选好了
        </div>
      </div>
    </>
  );
});
